<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">Przypisz {{ type === types.PARTNER ? 'partnerów' : 'usługi' }}</v-flex>

    <v-layout v-if="listStoreModule" column>
      <v-flex sm12 px2>
        <v-autocomplete
          v-model="selected"
          clearable
          hide-no-data
          cache-items
          item-text="name"
          item-value="id"
          return-object
          :placeholder="placeholder"
          :items="list"
          :search-input.sync="search"
        >
          <template v-slot:append-outer>
            <v-btn bottom large flat color="success" @click="add">Dodaj</v-btn>
          </template>

          <div slot="label">{{ type === types.PARTNER ? 'Partnerzy' : 'Usługi' }}</div>
        </v-autocomplete>
      </v-flex>

      <v-flex sm12 mx2>
        <v-layout v-for="(item, index) in this.$schema.entities.$items" :key="'entity_' + index">
          <v-flex sm8>{{ item.$item.name.$model }}</v-flex>

          <v-flex sm3 class="text-xs-right">
            <v-btn color="error" icon small flat @click="remove(item.$item.id.$model)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { schemaMixin } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import Modal from '@/components/material/Modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/assigmentMultiple.schema';

const types = {
  BENEFIT: 'benefit',
  PARTNER: 'partner',
  benefit: 'BENEFIT',
  partner: 'PARTNER'
};

const assignToModules = {
  BENEFIT: 'partners',
  PARTNER: 'benefit'
};

const listModules = {
  BENEFIT: 'benefit',
  PARTNER: 'partners'
};

// @vuese
// Przypisywanie benefitów/partnerów do partnera/benefitu
// @group modals
export default {
  components: { Modal },
  mixins: [schemaMixin, notificationsMixin],
  schema,
  props: {
    // Pokazanie modala
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    // Co ma zostać przypisane
    type: {
      type: String,
      required: true,
      validator: type => Object.values(types).indexOf(type) !== -1
    },
    // Identyfikator encji do przypisania
    id: {
      type: Number,
      required: true
    },
    // Obecne przypisania
    current: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      model: {},
      types,
      selected: undefined,
      search: '',
      assigned: []
    };
  },
  methods: {
    // @vuese
    // Wyszukanie encji
    searchData(search) {
      const filters = { search, count: 5 };
      if (this.listStoreModule === 'benefit') {
        filters.sharedOnly = true;
      }
      this.$store.dispatch(this.listStoreModule + '/list', filters);
    },
    // @vuese
    // Czyszczenie formularza
    clearData() {
      this.$schema.id.$setData(null);
      this.$schema.ids.$setLength(0);
      this.search = '';
      this.selected = undefined;
    },
    // @vuese
    // Dodawanie wybranej encji
    add() {
      if (
        this.selected &&
        this.$schema.entities.$items.findIndex(item => item.$item.id.$model === this.selected.id) === -1
      ) {
        this.$schema.entities.$addRow({ id: this.selected.id, name: this.selected.name });
        this.selected = null;
      }
    },
    // @vuese
    // Usuwanie wybranej encji
    remove(id) {
      const index = this.$schema.entities.$items.findIndex(item => item.$item.id.$model === id);
      this.$schema.entities.$removeRow(index);
    },
    // @vuese
    // Zamknięcie modala
    close() {
      this.$emit('close');
    },
    // @vuese
    // Zapisanie zmian w przypisaniu
    save() {
      this.add();
      this.$nextTick(() =>
        this.$store.dispatch(this.assignStoreModule + '/assign', this.$schema.$getData()).then(this.close)
      );
    }
  },
  watch: {
    search: {
      immediate: true,
      handler(val) {
        this.searchData(val);
      }
    },
    show(value) {
      if (value) {
        this.clearData();
        this.$schema.id.$setData(this.id);
        this.$schema.entities.$setData(this.current);
      }
    }
  },
  computed: {
    ...mapState({
      list(state) {
        return this.listStoreModule && state[this.listStoreModule].list;
      }
    }),
    listStoreModule() {
      return this.type && listModules[types[this.type]];
    },
    assignStoreModule() {
      return this.type && assignToModules[types[this.type]];
    },
    placeholder() {
      return `Wyszukaj ${this.type === types.PARTNER ? 'partnera' : 'usługi'}`;
    }
  }
};
</script>
